import { render, staticRenderFns } from "./ShowSystemMessages.vue?vue&type=template&id=5efc721c"
import script from "./ShowSystemMessages.vue?vue&type=script&lang=js"
export * from "./ShowSystemMessages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports